<template>
<div class="viewer-viewer">
  <OperatHeader>
    <div slot="left-action">
      <SearchInput></SearchInput>
    </div>
  </OperatHeader>
  <LeftDrawer>
    <div slot="header">
      <div class="top-tab">
        <slot name="btn"></slot>
        <div class="nav" :class="activeIndex === 1?'active':''" @click="switchActive(1)">
          <span>视点管理</span>
        </div>
        <div class="nav" :class="activeIndex === 2?'active':''" @click="switchActive(2)">
          <span>视点动画</span>
        </div>
      </div>
    </div>
    <!-- <div slot="body">
      <Empty></Empty>
    </div> -->
    <div class="ah" slot="body">
      <ViewPointList :pointList="viewPointsList" :viewType="1" ref="viewPoints" v-show="activeIndex === 1" @showView="onShowViewDetail" @refresh="getViewPointsList"></ViewPointList>
      <ViewPointList :pointList="viewAnimationsList" :viewType="2" ref="viewAnimation" v-show="activeIndex === 2" @showAnimation="onShowAnimationDetail" @refresh="getViewAnimationsList" @playViewAnimation="onPlayAnimation"></ViewPointList>
    </div>
  </LeftDrawer>
  <RightDrawer ref="rightDrawer" :hiddenDrawer="permissionLevel <= PermissionLevel.LOOKER">
    <div slot="header">
      <span class="title">基础设置</span>
      <!-- <Icon type="big" v-show="isViewChanged" name="icon-save" content="保存修改" @click.native="saveView"></Icon> -->
      <el-button type="primary" v-show="isViewChanged" :loading="loading" @click="saveView" class="save-btn">保存</el-button>
    </div>
    <div slot="body">
      <ViewPointSet :pointsList="viewPointsList" :animationsList="viewAnimationsList" ref="viewPointSet" @viewChanged="onViewChanged" @createPoint="onCreatePoint"></ViewPointSet>
    </div>
  </RightDrawer>
  <ViewControler ref="viewControler"></ViewControler>
</div>
</template>

<script>
import LeftDrawer from '@/components/Drawer/LeftDrawer'
import RightDrawer from '@/components/Drawer/RightDrawer'
import ViewPointList from './components/ViewPointList'
import ViewPointSet from './components/ViewPointSet'
import ViewControler from './components/ViewControler'
import OperatHeader from '@/components/OperatHeader/OperatHeader'
import SearchInput from '../components/POISearch/SearchInput'
import { mapGetters } from 'vuex'
import { getViewPointList, getViewAnimationList, addViewPoint, updateViewPoint, addViewAnimation, updateViewAnimation, getViewAnimation } from '@/api/viewer'
import { PermissionLevel } from '@/configs/constants'
export default {
  name: 'CesiumMarker',
  components: {
    LeftDrawer,
    RightDrawer,
    ViewPointList,
    ViewPointSet,
    ViewControler,
    OperatHeader,
    SearchInput
  },
  inject: ['shared'],
  data () {
    return {
      // viewPointsList: [
      //   {
      //     'defaulted': true,
      //     'frequently': true,
      //     'id': 0,
      //     'mapId': 0,
      //     'name': '',
      //     'view': {
      //       'cameraHeading': 0,
      //       'cameraPitch': 0,
      //       'cameraPosition': [],
      //       'cameraRoll': 0,
      //       'coverUrl': ''
      //     }
      //   }
      // ],
      // viewAnimationsList: [
      //   {
      //     'coverUrl': '',
      //     'defaulted': true,
      //     'frequently': true,
      //     'id': 0,
      //     'mapId': 0,
      //     'name': ''
      //   }
      // ],
      viewPointsList: [],
      viewAnimationsList: [],
      // 选中视图
      selectedView: undefined,
      // 视点属性是否改变
      isViewChanged: false,
      loading: false,

      activeIndex: 1,
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters(['isRightDrawVisible', 'userId', 'permissionLevel'])
  },
  beforeDestroy () {

  },
  mounted () {
    this.mapId = this.$route.query.mapId
    if (!this.mapId) {
      this.mapId = 0
    }

    // this.$store.dispatch('showRight', false)

    window.onmousedown = this.saveLayerCheck.bind(this)
    // document.getElementById('cesiumViewer').onclick = this.saveLayerCheck.bind(this)

    this.getViewPointsList()
    this.getViewAnimationsList()

    this.$nextTick(() => {
      this.$store.dispatch('showLeft', true)
      this.$store.dispatch('showRight', false)
    })
  },
  methods: {
    isInRightDrawer (event) {
      const clientWidth = document.body.clientWidth
      const clientHeight = document.body.clientHeight
      const left = clientWidth - 260
      const top = 47
      if (this.isRightDrawVisible && event.x < clientWidth && event.x > left && event.y > top && event.y < clientHeight) {
        return true
      }
    },
    saveLayerCheck (event) {
      if (this.isViewChanged && !this.isShowMessageBox && !this.isInRightDrawer(event)) {
        if (!this.$refs.viewPointSet.viewInfo.id) {
          this.$Submit({
            message: '您创建了新视点，是否保存？',
            confirmButtonText: '保存',
            cancelButtonText: '删除',
            confirm: () => {
              this.isShowMessageBox = false
              this.saveView()
            },
            cancel: () => {
              this.isShowMessageBox = false
              this.isViewChanged = false
              this.getViewAnimationsList()
              this.getViewPointsList()
              this.$refs.viewPoints.setSelectedIndex(undefined)
              this.$store.dispatch('showRight', false)
            }
          })
        } else {
          this.$Submit({
            message: '您修改了视点属性，是否保存？',
            confirmButtonText: '保存',
            cancelButtonText: '还原',
            confirm: () => {
              this.isShowMessageBox = false
              this.saveView()
            },
            cancel: () => {
              this.isShowMessageBox = false
              this.resetLayerStyle()
            }
          })
        }

        this.isShowMessageBox = true
      }
    },

    onViewChanged (data) {
      if (this.$refs.viewPointSet.viewInfo.name) {
        this.isViewChanged = true
      } else {
        this.isViewChanged = false
      }
    },
    switchActive (index) {
      this.activeIndex = index
      this.$store.dispatch('showRight', false)
    },
    // 创建新视点
    onCreatePoint (data) {
      // this.$refs.viewPoints.onCreatePoint(data)
      if (data.view) {
        this.$refs.viewPoints.onCreatePoint(data)
      } else {
        this.$refs.viewAnimation.onCreatePoint(data)
      }
      this.isViewChanged = true
    },
    // 保存更新图层属性
    saveView () {
      this.loading = true
      if (this.$refs.viewPointSet.viewType === 1) {
        if (!this.$refs.viewPointSet.viewInfo.id) {
          this.addViewPoint(this.$refs.viewPointSet.viewInfo)
        } else {
          this.updateViewPoint(this.$refs.viewPointSet.viewInfo)
        }
      } else if (this.$refs.viewPointSet.viewType === 2) {
        if (this.$refs.viewPointSet.viewInfo.viewpoints.length < 2) {
          this.$Message('warning', '动画至少包含两个视点')
          this.loading = false
          return
        }
        if (!this.$refs.viewPointSet.viewInfo.id) {
          this.addViewAnimation(this.$refs.viewPointSet.viewInfo)
        } else {
          this.updateViewAnimation(this.$refs.viewPointSet.viewInfo)
        }
      }
      // this.$refs.viewPointSet.setOrigin(this.selectedView)
    },
    addViewPoint (data) {
      addViewPoint(data).then(res => {
        if (res.code === 200) {
          this.isViewChanged = false
          this.loading = false
          this.$Message('success', res.msg || '操作成功！')
          this.getViewPointsList()
          this.$refs.viewPoints.setSelectedIndex(undefined)
          this.$store.dispatch('showRight', false)
        }
      }).catch(res => {
        this.loading = false
      })
    },
    updateViewPoint (data) {
      updateViewPoint(data).then(res => {
        if (res.code === 200) {
          this.isViewChanged = false
          this.loading = false
          this.$Message('success', res.msg || '操作成功！')
          this.getViewPointsList()
          this.$refs.viewPoints.setSelectedIndex(undefined)
          this.$store.dispatch('showRight', false)
        }
      }).catch(res => {
        this.loading = false
      })
    },
    addViewAnimation (data) {
      addViewAnimation(data).then(res => {
        if (res.code === 200) {
          this.isViewChanged = false
          this.loading = false
          this.$Message('success', res.msg || '操作成功！')
          this.getViewAnimationsList()
          this.$refs.viewAnimation.setSelectedIndex(undefined)
          this.$store.dispatch('showRight', false)
        }
      }).catch(res => {
        this.loading = false
      })
    },
    updateViewAnimation (data) {
      updateViewAnimation(data).then(res => {
        if (res.code === 200) {
          this.isViewChanged = false
          this.loading = false
          this.$Message('success', res.msg || '操作成功！')
          this.getViewAnimationsList()
          this.$refs.viewAnimation.setSelectedIndex(undefined)
          this.$store.dispatch('showRight', false)
        }
      }).catch(res => {
        this.loading = false
      })
    },
    // 还原图层属性
    resetLayerStyle () {
      // this.$refs.viewPointSet.resetData()
      if (this.$refs.viewPointSet.viewType === 1) {
        this.$refs.viewPoints.onResetPoint()
        this.$refs.viewPoints.setHaveNewPoint(false)
      } else if (this.$refs.viewPointSet.viewType === 2) {
        this.$refs.viewAnimation.onResetPoint()
        this.$refs.viewAnimation.setHaveNewPoint(false)
      }

      this.$nextTick(() => {
        this.isViewChanged = false
        // this.$refs.viewPoints.setHaveNewPoint(false)
      })
    },
    // 获取视点列表
    getViewPointsList () {
      getViewPointList({
        mapId: this.mapId
      }).then(res => {
        if (res.code === 200) {
          this.viewPointsList = res.data
          this.$refs.viewPoints.setHaveNewPoint(false)
        }
      })
    },
    // 获取动画列表
    getViewAnimationsList () {
      getViewAnimationList({
        mapId: this.mapId
      }).then(res => {
        if (res.code === 200) {
          this.viewAnimationsList = res.data
          this.$refs.viewAnimation.setHaveNewPoint(false)
        }
      })
    },
    // 显示视图详情
    onShowViewDetail (data) {
      this.$store.dispatch('showRight', true)
      if (data) {
        this.selectedView = JSON.parse(JSON.stringify(data))
        this.$refs.viewPointSet.setData(this.selectedView, 1)
      } else {
        this.$refs.viewPointSet.setData(data, 1)
      }
    },
    // 显示动画详情
    onShowAnimationDetail (data) {
      this.$store.dispatch('showRight', true)
      if (data) {
        this.selectedView = JSON.parse(JSON.stringify(data))
        this.$refs.viewPointSet.setData(this.selectedView, 2)
      } else {
        this.$refs.viewPointSet.setData(data, 2)
      }
    },
    // 播放视点动画
    onPlayAnimation (data) {
      if (this.selectedView && data.id === this.selectedView.id) {
        this.$refs.viewControler.show(this.selectedView)
      } else {
        // 获取动画的视点列表
        getViewAnimation({
          id: data.id
        }).then(res => {
          if (res.code === 200) {
            this.$refs.viewControler.show(res.data)
          }
        })
      }
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.viewer-viewer{
  .left-drawer {
    .top-tab{
      flex: 1;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: start;
      box-sizing: border-box;
      .nav{
        font-size: 14px;
        color: rgba(255, 255, 255, 0.3);
        font-family: Source Han Sans SC;
        font-weight: 300;
        cursor: pointer;
        margin-left: 27px;
        transition: all 0.3s;
        &:hover{
          color: #FFFFFF;
        }
        &.active{
          color: #FFFFFF;
        }
      }
      .el-dropdown{
        .el-dropdown-link{
          font-size: 14px;
          color: rgba(255, 255, 255, 0.3);
          font-family: Source Han Sans SC;
          font-weight: 300;
        }
      }
    }
  }
  .header{
    // text-align: left;
    line-height: 40px;
    .title{
      float: left;
      margin-left: 10px;
    }
    .save-btn{
      height:24px;
      font-size: 12px !important;
      padding:0 5px !important;
      float: right;
      margin-right: 10px;
      margin-top: 7px;
    }
    .icons{
      float: right;
      margin-right: 10px;
      padding-top: 4px;
    }
  }
  .body{
    font-size: $font-size12;
    .statistics{
      color: $font-color9;
      margin-left: 12px;
      margin-top: 15px;
      margin-bottom: 10px;
      float: left;
    }
    .layer-list{
      margin-top: 10px;
      max-height: 600px;
      overflow-y: overlay;
      padding: 8px;
      width: 100%;
      .layer-item{
        // height: 32px;
        // background: rgba($font-colorf, 0.1);
        // border-radius: 6px;
        .title{
          display: inline-block;
          width: 120px;
          text-align: left;
          vertical-align: bottom;
          height: 32px;
          line-height: 32px;
          @include show_ellipsis(1);
        }
        .count{
          margin-left: 8px;
          color: #999;
        }
        .action-icon{
          float: right;
        }
        .custom-icon{
          transform: scale(0.8);
          opacity: 0.3;
        }
        .layerIconStyle{
          &:hover{
            background-color: unset !important;
          }
        }
      }
    }
    // .el-icon-more{
    //   transform: rotate(90deg);
    //   font-size: 14px;
    // }
  }
  .right-drawer{
    .header{
      .custom-icon{
        float: right;
        margin-right: 10px;
        margin-top: 3px;
      }
    }
  }
}
</style>
